import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import {
  Card,
  CardContent,
  FormControl,
  Select,
  Grid,
  InputLabel,
  TextField,
  FormHelperText,
  MenuItem,
  Input,
} from "@material-ui/core";
import { yupResolver } from "@hookform/resolvers/yup";
import { getMaestras } from "../../actions/maestras-actions";
import { useStateValue } from "../../context/store";
import { styles } from "../styles";
import { TextMaskCustom } from "../curriculumVitae/help";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { createUserInternal } from "../../actions/user-actions";
import { getAllRoleByStatus } from "../../actions/role-actions";
import { ERROR_MESSAGE, REQUIRED_MESSAGE } from "../../constants";
import DateFnsUtils from "@date-io/date-fns";
import deLocale from "date-fns/locale/es";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { titleCase } from "title-case";
import Utils from "../../utils/utils";
import _ from "lodash";
import moment from "moment";
import * as yup from "yup";

const defaultValue = {
  roleList: [],
  cargoId: "",
  secondName: "",
  secondSurname: "",
};

const UserUpdateModalForm = (props) => {
  let lastDay = new Date(new Date().getFullYear(), 11, 31);
  const [lastDayYear, setLastDayYear] = useState(
    Utils.getFormattedDateMMddyyyy(lastDay, ".")
  );
  const classes = styles();
  const [{}, dispatch] = useStateValue();
  const [allRoles, setAllRoles] = useState([]);
  const [onSubmitDisabled, setSubmitDisabled] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [resetForm, setResetForm] = useState(defaultValue);
  const [user, setUser] = useState({});
  const [employee, setEmployee] = useState(props?.dataUser?.data);
  const [showTelephoneMessage, setShowTelephoneMessage] = useState(false);
  const [showCellPhoneMessage, setShowCellPhoneMessage] = useState(false);
  const [telephoneMessage, setTelephoneMessage] = useState(
    "Favor digitar indicativo de la zona"
  );
  /* const [usuario, setUsuario] = useState({
      username: "admin",
      reValidatePassword: false,
      showPassword: false,
    }); */
  const [maestras, setMaestras] = useState({
    generos: [],
    tipoDocumnetoIdentificacion: [],
  });

  useEffect(() => {
    const getListaMaestras = async () => {
      const response = await getMaestras();
      setMaestras(response?.data?.maestras);
    };
    getListaMaestras();

    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Crear Usuario interno",
      breadCrumbSubText: "Crear Usuario interno",
      index: 39,
      subPath: "/dashboard/user",
      isSubmit: props?.dataUser?.data?.status === "ACTIVO" ? true : false,
    });
  }, []);

  const onChangeValues = (e) => {
    const { name, value } = e.target;
    setResetForm({ ...resetForm, [name]: value });
  };

  const validteDate = () => {
    const currentyear = moment().year() - 1;
    return moment(currentyear + "-12-31").toDate();
  };

  const schema = yup.object().shape({
    // username: yup
    // .string()
    // .nullable()
    // .required(REQUIRED_MESSAGE)
    // .min(5, "Ingrese mínimo 5 caracteres")
    // .max(80, "Ingrese máximo 80 caracteres")
    // .matches(
    //   /^(?=.{0,80}$)(([A-Za-z](|\(|\))?))+$/,
    //   "Ingrese un usuario válido"
    // ),
    gender: yup.string().nullable().required(REQUIRED_MESSAGE),
    firstName:
      resetForm.firstName !== ""
        ? null
        : yup
            .string()
            .required(REQUIRED_MESSAGE)
            .min(3, "Ingrese mínimo 3 caracteres")
            .max(80, "Ingrese máximo 80 caracteres")
            .matches(/^(([A-Za-zÀ-ÿ])+[ ]?)*$/g, "Ingrese un nombre válido"),
    // secondName:
    //   resetForm.secondName !== ""
    //     ? null
    //     : yup
    //         .string()
    //         .notRequired()
    //         .min(3, "Ingrese mínimo 3 caracteres")
    //         .max(80, "Ingrese máximo 80 caracteres")
    //         .matches(/^(([A-Za-zÀ-ÿ])+[ ]?)*$/g, "Ingrese un nombre válido"),
    surname:
      resetForm.surname !== ""
        ? null
        : yup
            .string()
            .required(REQUIRED_MESSAGE)
            .min(3, "Ingrese mínimo 3 caracteres")
            .max(80, "Ingrese máximo 80 caracteres")
            .matches(/^(([A-Za-zÀ-ÿ])+[ ]?)*$/g, "Ingrese un apellido válido"),
    secondSurname:
      resetForm.secondSurname === ""
        ? null
        : yup
            .string()
            .notRequired()
            .min(3, "Ingrese mínimo 3 caracteres")
            .max(80, "Ingrese máximo 80 caracteres")
            .matches(/^(([A-Za-zÀ-ÿ])+[ ]?)*$/g, "Ingrese un apellido válido"),
    cargoId: yup.string().nullable().required(REQUIRED_MESSAGE),
    external: yup
      .string()
      .required(REQUIRED_MESSAGE)
      .email("Ingrese un correo electrónico válido")
      .min(8, "Ingrese mínimo 8 caracteres")
      .max(50, "Ingrese máximo 50 caracteres"),
    internalEmail: yup
      .string()
      .required(REQUIRED_MESSAGE)
      .email("Ingrese un correo electrónico válido")
      .min(8, "Ingrese mínimo 8 caracteres")
      .max(50, "Ingrese máximo 50 caracteres"),
    phone: yup
      .string()
      .transform(
        function (value) {
          let valor = value
            ?.replace(/\(/g, "")
            ?.replace(/\)/g, "")
            ?.replace(/\-/g, "")
            ?.replace(/\s+/g, "");
          if (valor === "") return null;
          return valor;
        }
      )
      .notRequired()
      .nullable(true)
      .min(10, "Ingrese indicativo y mínimo 7 dígitos"),
    cellPhoneNumber:
      resetForm.cellPhoneNumber !== ""
        ? null
        : yup
            .string()
            .nullable()
            .transform((value) =>
              value
                .replace(/\s+/g, "")
                .split(" ")
                .join("")
                .replace("(", "")
                .replace(")", "")
                .replace("-", "")
                .replace(" ", "")
                .trim()
            )
            .required(REQUIRED_MESSAGE)
            .min(10, "Ingrese mínimo 10 dígitos"),
    dateBirth: yup
      .date()
      .nullable()
      .required(REQUIRED_MESSAGE)
      .min(
        new Date(1899, 11, 31, 23, 59, 29),

        `No puede ser menor a la fecha de 1900`
      )
      .max(validteDate(), `La fecha debe ser menor al año actual`)
      .nullable()
      .typeError("Ingrese un formato de fecha válido"),
    roleList: resetForm?.roleList?.length
      ? null
      : yup.string().nullable().required(REQUIRED_MESSAGE),
  });

  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      firstName: employee.firstName,
      secondName: employee.secondName,
      surname: employee.surname,
      secondSurname: employee.secondSurname,
      documentType: employee.documentType,
      documentNumber: employee.documentNumber,
      email: employee.personalEmail,
      phone: employee.phone,
      type: employee.type,
      cellPhoneNumber: employee.cellPhoneNumber,
      gender: employee.gender,
      status: employee.status,
      creationUser: "Developer",
    },
    mode: "all",
    reValidateMode: "onChange",
  });

  const getStatesForm = async () => {
    const response = await getAllRoleByStatus("ACTIVO");
    setAllRoles(
      _.sortBy(response?.data?.roleList, [
        function (o) {
          return o.name;
        },
      ])
    );
    if (props?.dataUser?.data?.externalEmail) {
      setValue("cellPhoneNumber", props?.dataUser?.data?.cellPhoneNumber);
      setResetForm({
        ...resetForm,
        cargoId: props?.dataUser?.data?.charge?.id,
      });
      setValue("dateBirth", props?.dataUser?.data?.dateBirth);
      setValue("documentNumber", props?.dataUser?.data?.documentNumber);
      setValue("documentType", props?.dataUser?.data?.documentType);
      setValue("gender", props?.dataUser?.data?.domainGender);
      setValue("external", props?.dataUser?.data?.externalEmail);
      setValue("firstName", props?.dataUser?.data?.firstName);
      setValue("secondName", props?.dataUser?.data?.secondName);
      setValue("secondSurname", props?.dataUser?.data?.secondSurname);
      setValue("surname", props?.dataUser?.data?.surname);
      setValue("phone", props?.dataUser?.data?.phone);
    } else {
      setDisabled(true);
      setResetForm({
        ...resetForm,
        //roleList: props?.dataUser?.data?.roleList,
        cargoId: props?.dataUser?.data?.charge?.id,
      });
      setValue("username", props?.dataUser?.data?.internalEmail);
      setValue("documentType", props?.dataUser?.data?.documentType);
      setValue("documentNumber", props?.dataUser?.data?.documentNumber);
      setValue("firstName", props?.dataUser?.data?.firstName);
      setValue("secondName", props?.dataUser?.data?.secondName);
      setValue("surname", props?.dataUser?.data?.surname);
      setValue("secondSurname", props?.dataUser?.data?.secondSurname);
      setValue("internalEmail", props?.dataUser?.data?.internalEmail);
      setValue("external", props?.dataUser?.data?.personalEmail);
      setValue("phone", props?.dataUser?.data?.phone);
      setValue("cellPhoneNumber", props?.dataUser?.data?.cellPhoneNumber);
      setValue("gender", props?.dataUser?.data?.gender);
      setValue("dateBirth", props?.dataUser?.data?.dateBirth);
      setValue("domainstatus", props?.dataUser?.data?.domainstatus);
      setValue("cargoId", props?.dataUser?.data?.charge?.id);
      setUser(user);
    }
  };
  useEffect(() => {
    getStatesForm();
  }, []);

  //const isBack = () => window.history.back();
  const handleClickCloseAndReset = () => {
    window.location.assign("/dashboard/user");
    //props.handleClickReset();
    setSubmitDisabled(false);
  };

  const handleClickCloseModal = () => {
    props.setMessage({ ...props.message, open: false });
    setSubmitDisabled(false);
  };

  const showFirstName = watch("firstName");
  const showSecondName = watch("secondName");
  const showSurname = watch("surname");
  const showSecondSurname = watch("secondSurname");
  const showPhone = watch("phone");
  const showCellPhoneNumber = watch("cellPhoneNumber");

  const onSubmit = (data) => {
    if (data?.internalEmail === data?.external) {
      props.setMessage({
        description: `Ingresa un correo electrónico diferente`,
        textButtonSubmit: "Aceptar",
        handleClick: () => handleClickCloseModal(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    } else {
      const infoExternalUser = {
        externalEmail: data?.external
          ? data?.external
          : props?.dataUser?.data?.externalEmail,
        status: "ACTIVO",
        personId: null,
        roleList: resetForm?.roleList?.map(function (item) {
          return item["id"];
        }),
        cellPhoneNumber: showCellPhoneNumber
          ?.replace("(", "")
          ?.replace(")", "")
          ?.replace("-", "")
          ?.replace(" ", "")
          ?.trim(),
        cargoId: data?.cargoId,
        dateBirth: moment(data.dateBirth).format("YYYY-MM-DDTHH:mm"),
        //dateBirth: moment(data.dateBirth).format('YYYY-MM-DD HH:mm:ss'),
        documentNumber: props?.dataUser?.data?.document,
        documentType: props?.dataUser?.data?.documentType,
        firstName: showFirstName,
        gender: data?.gender,
        internalEmail: data?.internalEmail,
        username: data?.internalEmail,
        phone: showPhone
          ?.replace("(", "")
          ?.replace(")", "")
          ?.replace("-", "")
          ?.replace(" ", "")
          ?.trim(),
        secondName: showSecondName ? showSecondName : null,
        secondSurname: showSecondSurname ? showSecondSurname : null,
        surname: showSurname,
        password: data?.validatePassword,
      };

      props.setMessage({
        description: "¿Está seguro que desea crear el registro?",
        textButtonSubmit: "Aceptar",
        handleClick: () => userInternal(infoExternalUser),
        handleClickOut: () => handleClickCloseModal(),
        type: "WARNING",
        open: true,
      });
    }
  };

  const handleUserKeyPress = (e) => {
    let invalidChars = ["-", "e", "+", "E", ".", ","];
    if (invalidChars.includes(e.key)) {
      e.preventDefault();
    }
  };

  const onTelephoneChange = (e) => {
    e.preventDefault();
    const { value, name } = e.target;
    if (
      name === "cellPhoneNumber" &&
      parseInt(value) > 999999 &&
      parseInt(value) < 999999999
    ) {
      setShowCellPhoneMessage(true);
    } else {
      setShowCellPhoneMessage(false);
    }
    if (
      name === "phone" &&
      parseInt(value) > 999999 &&
      parseInt(value) < 999999999
    ) {
      setShowTelephoneMessage(true);
    } else {
      setShowTelephoneMessage(false);
    }
  };

  const userInternal = async (data) => {
    props.setMessage({ ...props.message, open: false });
    const token = JSON.stringify(localStorage.getItem("token_app"));
    const response = await createUserInternal(data, token);
    if (response && (response?.status === 200 || response?.status === 201)) {
      props.setMessage({
        description: `Usuario creado exitosamente`,
        textButtonSubmit: "Aceptar",
        handleClick: () => handleClickCloseAndReset(),
        oneButtons: true,
        type: "SUCCESS",
        open: true,
      });
    } else if (
      response?.status > 399 &&
      response?.status !== 401 &&
      response?.status !== 403
    ) {
      props.setMessage({
        description: response?.data?.detail
          ? response?.data?.detail
          : ERROR_MESSAGE,
        textButtonSubmit: "ACEPTAR",
        handleClick: () => handleClickCloseModal(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    } else {
      props.setMessage({
        description: `Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
        textButtonSubmit: "ACEPTAR",
        handleClick: () => handleClickCloseModal(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    }
  };

  return (
    <React.Fragment>
      <Card elevation={0} style={{ background: "#e0f2f7" }}>
        <CardContent>
          <form id="formUserInternal" onSubmit={handleSubmit(onSubmit)}>
            <Grid
              container
              spacing={3}
              alignItems="center"
              style={{ borderRadius: 15, display: "flex" }}
            >
              {/* <Grid item xs={12} md={4} lg={4}>
              <FormControl fullWidth>
                <TextField
                  fullWidth
                  type="text"
                  variant="outlined"
                  disabled={ disabled ? true : false}
                  inputRef={register}
                  className = {classes.dropdown}
                  label="Nombre de usuario"
                  name="username"
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  error={
                    !!errors.hasOwnProperty("username") &&
                    errors["username"].message
                  }
                  helperText={
                    errors.hasOwnProperty("username") &&
                    errors["username"].message
                  }
                />
              </FormControl>
            </Grid> */}
              <Grid item xs={12} md={4} lg={4}>
                <FormControl
                  variant="outlined"
                  fullWidth
                  size="small"
                  error={
                    !!errors.hasOwnProperty("gender") &&
                    errors["gender"].message
                  }
                >
                  <InputLabel htmlFor="outlined-select-gender" shrink={true}>
                    Género
                  </InputLabel>
                  <Controller
                    fullWidth
                    control={control}
                    inputRef={register}
                    disabled={disabled ? true : false}
                    className={classes.dropdown}
                    label="Género"
                    name="gender"
                    size="small"
                    notched={true}
                    inputProps={{
                      name: "gender",
                      id: "outlined-select-gender",
                    }}
                    as={
                      <Select>
                        {maestras?.generos?.map((gender) => (
                          <MenuItem
                            className={classes.menuItem}
                            key={gender.index}
                            value={gender.key}
                          >
                            {gender.key}
                          </MenuItem>
                        ))}
                      </Select>
                    }
                  />
                  <FormHelperText>
                    {errors.hasOwnProperty("gender") &&
                      errors["gender"].message}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <FormControl
                  variant="outlined"
                  fullWidth
                  size="small"
                  error={
                    !!errors.hasOwnProperty("firstName") &&
                    errors["firstName"].message
                  }
                >
                  <Controller
                    control={control}
                    name="firstName"
                    rules={{ required: true }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        type="text"
                        variant="outlined"
                        disabled={disabled ? true : false}
                        //inputProps={{ maxLength: 80 }}
                        inputRef={register}
                        className={classes.dropdown}
                        label="Primer Nombre *"
                        name="firstName"
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        error={
                          errors.hasOwnProperty("firstName") &&
                          errors["firstName"].message
                        }
                      />
                    )}
                  />
                  <FormHelperText style={{ color: "#f44336", paddingLeft: 0 }}>
                    {errors.hasOwnProperty("firstName") &&
                      errors["firstName"].message}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <FormControl fullWidth>
                  <TextField
                    fullWidth
                    type="text"
                    variant="outlined"
                    inputRef={register}
                    onChange={onChangeValues}
                    disabled={disabled ? true : false}
                    className={classes.dropdown}
                    label="Segundo Nombre"
                    name="secondName"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    error={
                      resetForm.secondName === ""
                        ? null
                        : !!errors.hasOwnProperty("secondName") &&
                          errors["secondName"].message
                    }
                    helperText={
                      resetForm.secondName === ""
                        ? null
                        : errors.hasOwnProperty("secondName") &&
                          errors["secondName"].message
                    }
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <FormControl fullWidth>
                  <TextField
                    fullWidth
                    type="text"
                    variant="outlined"
                    disabled={disabled ? true : false}
                    //inputProps={{ maxLength: 80 }}
                    inputRef={register}
                    className={classes.dropdown}
                    label="Primer Apellido *"
                    name="surname"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    error={
                      errors.hasOwnProperty("surname") &&
                      errors["surname"].message
                    }
                    helperText={
                      errors.hasOwnProperty("surname") &&
                      errors["surname"].message
                    }
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  inputRef={register}
                  type="text"
                  name="secondSurname"
                  fullWidth
                  className={classes.dropdown}
                  variant="outlined"
                  disabled={disabled ? true : false}
                  //inputProps={{ maxLength: 80 }}
                  label="Segundo Apellido"
                  size="small"
                  onChange={onChangeValues}
                  error={
                    resetForm.secondSurname === ""
                      ? null
                      : errors.hasOwnProperty("secondSurname") &&
                        errors["secondSurname"].message
                  }
                  helperText={
                    resetForm.secondSurname === ""
                      ? null
                      : errors.hasOwnProperty("secondSurname") &&
                        errors["secondSurname"].message
                  }
                />
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <FormControl
                  variant="outlined"
                  fullWidth
                  size="small"
                  error={
                    !!errors.hasOwnProperty("cargoId") &&
                    errors["cargoId"].message
                  }
                >
                  <InputLabel htmlFor="outlined-select-cargoId" shrink={true}>
                    Cargo *
                  </InputLabel>
                  <Controller
                    control={control}
                    name="cargoId"
                    inputRef={register}
                    fullWidth
                    defaultValue=""
                    disabled={disabled ? true : false}
                    className={classes.dropdown}
                    label="Cargo *"
                    size="small"
                    notched={true}
                    inputProps={{
                      name: "cargoId",
                      id: "outlined-select-cargoId",
                    }}
                    as={
                      <Select>
                        {props?.charges?.map((c) => (
                          <MenuItem
                            className={classes.menuItem}
                            id={c.id}
                            key={c.id}
                            value={c.id}
                          >
                            {c.denomination}
                          </MenuItem>
                        ))}
                      </Select>
                    }
                  />
                  <FormHelperText>
                    {errors.hasOwnProperty("cargoId") &&
                      errors["cargoId"].message}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <FormControl fullWidth>
                  <TextField
                    fullWidth
                    variant="outlined"
                    disabled={false}
                    inputRef={register}
                    className={classes.dropdown}
                    label="Correo personal *"
                    placeholder="ejemplo@correo.com"
                    name="external"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    error={
                      !!errors.hasOwnProperty("external") &&
                      errors["external"].message
                    }
                    helperText={
                      errors.hasOwnProperty("external") &&
                      errors["external"].message
                    }
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <FormControl fullWidth>
                  <TextField
                    fullWidth
                    variant="outlined"
                    type="text"
                    disabled={false}
                    className={classes.dropdown}
                    inputRef={register}
                    label="Correo corporativo *"
                    placeholder="ejemplo@correo.com"
                    name="internalEmail"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    error={
                      !!errors.hasOwnProperty("internalEmail") &&
                      errors["internalEmail"].message
                    }
                    helperText={
                      errors.hasOwnProperty("internalEmail") &&
                      errors["internalEmail"].message
                    }
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <FormControl
                  fullWidth
                  style={{ marginTop: "0px" }}
                  error={
                    !!errors.hasOwnProperty("phone") && errors["phone"].message
                  }
                >
                  <InputLabel
                    htmlFor="phone"
                    style={{
                      zIndex: 2,
                      marginTop: "-7px",
                      paddingLeft: "10px",
                    }}
                  >
                    No. Teléfono
                  </InputLabel>
                  <Input
                    id="phone"
                    inputComponent={TextMaskCustom}
                    disabled={disabled ? true : false}
                    variant="outlined"
                    type="text"
                    notched={true}
                    inputRef={register}
                    className={classes.formField}
                    style={{ marginTop: "0px" }}
                    inputProps={{
                      style: {
                        height: "18px",
                        borderRadius: "8px",
                        paddingBottom: "0px",
                        fontSize: 14,
                        paddingLeft: "12px",
                      },
                    }}
                    onKeyPress={handleUserKeyPress}
                    onChange={onTelephoneChange}
                    name="phone"
                    size="small"
                  />
                  <FormHelperText style={{ color: "#f44336" }}>
                    {errors.hasOwnProperty("phone") && errors["phone"].message}
                  </FormHelperText>
                  <FormHelperText style={{ color: "#f44336" }}>
                    {showTelephoneMessage && telephoneMessage}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <FormControl fullWidth>
                  <MuiPickersUtilsProvider
                    locale={deLocale}
                    utils={DateFnsUtils}
                  >
                    <Controller
                      as={
                        <KeyboardDatePicker
                          fullWidth
                          disabled={disabled ? true : false}
                          inputVariant="outlined"
                          variant="inline"
                          required
                          name="dateBirth"
                          className={classes.dropdown}
                          format="dd/MM/yyyy"
                          label="Fecha de nacimiento"
                          InputLabelProps={{ shrink: true }}
                          error={
                            !!errors.hasOwnProperty("dateBirth") &&
                            errors["dateBirth"].message
                          }
                          helperText={
                            errors.hasOwnProperty("dateBirth") &&
                            errors["dateBirth"].message
                          }
                          maxDate={lastDayYear}
                        />
                      }
                      control={control}
                      name="dateBirth"
                      placeholder="Fecha de nacimiento"
                      size="small"
                    />
                  </MuiPickersUtilsProvider>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <FormControl
                  fullWidth
                  style={{ marginTop: "0px" }}
                  error={
                    !!errors.hasOwnProperty("cellPhoneNumber") &&
                    errors["cellPhoneNumber"].message
                  }
                >
                  <InputLabel
                    htmlFor="cellPhoneNumber"
                    style={{
                      zIndex: 2,
                      marginTop: "-7px",
                      paddingLeft: "10px",
                    }}
                  >
                    No. Celular *
                  </InputLabel>
                  <Input
                    id="cellPhoneNumber"
                    inputComponent={TextMaskCustom}
                    disabled={disabled ? true : false}
                    variant="outlined"
                    type="text"
                    notched={true}
                    inputRef={register}
                    className={classes.formField}
                    style={{ marginTop: "0px" }}
                    inputProps={{
                      style: {
                        height: "18px",
                        borderRadius: "8px",
                        paddingBottom: "0px",
                        fontSize: 14,
                        paddingLeft: "12px",
                      },
                    }}
                    onKeyPress={handleUserKeyPress}
                    onChange={onTelephoneChange}
                    name="cellPhoneNumber"
                    size="small"
                  />
                  <FormHelperText style={{ color: "#f44336" }}>
                    {errors.hasOwnProperty("cellPhoneNumber") &&
                      errors["cellPhoneNumber"].message}
                  </FormHelperText>
                  <FormHelperText style={{ color: "#f44336" }}>
                    {showCellPhoneMessage && telephoneMessage}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <FormControl fullWidth>
                  <Autocomplete
                    multiple
                    disabled={false}
                    name="roleList"
                    value={resetForm?.roleList}
                    options={allRoles}
                    className={classes.dropdownMultiple}
                    onChange={(e, newval, reason) => {
                      setResetForm({ ...resetForm, roleList: newval });
                    }}
                    getOptionLabel={(option) => titleCase(option?.name)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        inputRef={register}
                        name="roleList"
                        label="Roles *"
                        InputLabelProps={{ shrink: true }}
                        placeholder="Rol ABC"
                        error={
                          resetForm.roleList.length <= 0
                            ? errors.hasOwnProperty("roleList") &&
                              errors["roleList"].message
                            : ""
                        }
                      />
                    )}
                  />
                  <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                    {resetForm?.roleList?.length <= 0
                      ? errors.hasOwnProperty("roleList") &&
                        errors["roleList"].message
                      : ""}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4} lg={4} style={{ margin: "auto" }}>
                {/* <ColorButton style={{ width: "200px" }} type="submit" disabled={onSubmitDisabled}>
                GUARDAR
              </ColorButton>
              <Button  style = {{backgroundColor: 'transparent', marginLeft: 10, color: '#7EBDCE'}} onClick={isBack}>CANCELAR</Button>&nbsp;&nbsp; */}
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>
    </React.Fragment>
  );
};

export default UserUpdateModalForm;
